// [임시] 수동 리드 추가 폼의 광고주별 상담 항목 프리셋.
// 나중에 제거하려면 이 파일을 지우고 AdvertiserLeadsSection 의 import 한 줄만 빼면 됨
// (없으면 프리셋 없이 빈 항목 목록으로 동작). DB/백엔드와 무관한 FE 편의 값.
export const LEAD_FIELD_PRESETS: Record<string, string[]> = {
  pnl: [
    "응답자 생년월일",
    "응답자 성별",
    "현재 직업을 선택해주세요.",
    "월 평균 소득을 선택해주세요.",
    "차량 보유 여부를 선택해주세요.",
    "현재 혼인 상태를 선택해주세요.",
    "현재 거주 형태를 선택해주세요.",
    "현재 채무 금액을 선택해주세요.",
    "과거 회생 신청 여부를 선택해주세요.",
    "희망하는 상담 종류를 선택해주세요.",
    "톡 채널추가여부",
    "참여형 광고 개선을 위한 응답 활용 동의",
    "서비스기여",
    "소재 ID",
    "최종 계약 여부",
  ],
  hr: [
    "응답자 생년월일",
    "응답자 성별",
    "현재 어떤 일을 하고 계신가요?",
    "월 평균 소득은 어느 정도이신가요?",
    "현재 차량을 보유하고 계신가요?",
    "현재 혼인 상태는 어떻게 되시나요?",
    "현재 거주 형태는 어떻게 되시나요?",
    "현재 채무 금액은 어느 정도인가요?",
    "과거 개인회생을 신청하신 경험이 있으신가요?",
    "희망하시는 상담 유형이 어떻게 되시나요?",
    "톡 채널추가여부",
    "참여형 광고 개선을 위한 응답 활용 동의",
    "서비스기여",
    "소재 ID",
    "최종 계약 여부",
  ],
};
